import { isEditableElement } from "./utils/is_editable_element.js";

// Skips applying an incoming Turbo Stream action if its target contains an
// element the user is actively typing into AND that element holds text no
// request has captured yet — a broadcast (or a stale same-request response)
// landing mid-keystroke should never overwrite unsaved text. Deliberately
// scoped to EDITABLE focus only — a focused button or link is not something
// a user is "typing into," and vetoing those would silently break
// same-request row replaces (e.g. clicking a button leaves it focused, and
// the resulting response often targets a container that button sits in).
//
// The "no request has captured it yet" half matters for fields whose own
// response redraws their own container — a cart quantity stepper, a PV
// pencil editor — where blanket-vetoing every same-request response would
// silently freeze the field forever (its own authoritative echo, including
// server-side clamping, could never land). Snapshot the focused element's
// value whenever a request starts; at render time, if the target still holds
// exactly that snapshot, nothing has been typed since firing this request,
// so there's nothing left to protect. If the value has since moved on (the
// user kept typing while this request was in flight, or a different field is
// mid-edit and an unrelated broadcast arrived), the snapshot won't match and
// the veto still applies.
let pendingElement = null;
let pendingValue = null;

function editableValue(element) {
	return element.value ?? element.textContent;
}

document.addEventListener("turbo:before-fetch-request", () => {
	const activeElement = document.activeElement;
	pendingElement = isEditableElement(activeElement) ? activeElement : null;
	pendingValue = pendingElement && editableValue(pendingElement);
});

document.addEventListener("turbo:before-stream-render", (event) => {
	const activeElement = document.activeElement;
	if (!isEditableElement(activeElement)) return;

	const target = event.target.getAttribute("target");
	if (!target) return;

	const targetElement = document.getElementById(target);
	if (!targetElement?.contains(activeElement)) return;

	if (activeElement === pendingElement && editableValue(activeElement) === pendingValue) return;

	event.preventDefault();
});
